import { createContext, useContext, useState, useEffect, useMemo } from "react";

const STORAGE_KEY = "revhub_selected_year";
const AVAILABLE_YEARS = [2026, 2027];

const YearContext = createContext(null);

export const YearProvider = ({ children }) => {
  // Default: el año actual del sistema si está en la lista, si no el primero
  const currentYear = new Date().getFullYear();
  const defaultYear = AVAILABLE_YEARS.includes(currentYear) ? currentYear : AVAILABLE_YEARS[0];

  const [year, setYear] = useState(() => {
    try {
      const stored = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      return AVAILABLE_YEARS.includes(stored) ? stored : defaultYear;
    } catch {
      return defaultYear;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(year));
    } catch {}
  }, [year]);

  const value = useMemo(
    () => ({ year, setYear, availableYears: AVAILABLE_YEARS }),
    [year]
  );

  return <YearContext.Provider value={value}>{children}</YearContext.Provider>;
};

export const useYear = () => {
  const ctx = useContext(YearContext);
  if (!ctx) throw new Error("useYear debe usarse dentro de YearProvider");
  return ctx;
};
